export function isOptionGroup(child) {
  return !!child.options;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/base/SelectUnstyled/useSelect.types.js
// module id = 525
// module chunks = 1